// @flow

/* eslint-disable import/prefer-default-export */

export const getClassName: Function = (componentClassName = "") =>
  (elementClassName = null) =>
    [componentClassName]
      .concat(elementClassName)
      .join(elementClassName && elementClassName.indexOf("_") !== 0 ? "__" : "");

export const addModifierTo: Function = (componentClassName = "") =>
  (modifier = null) => `${componentClassName}--${modifier}`;




// WEBPACK FOOTER //
// ./src/ui-kit/utils/component.js